import styled from 'styled-components';

export const MessageContainer = styled.div`
  padding: 0 1.5rem 1rem;
`;
